import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCalendarAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const MiniERPAttendance = ({ authState }) => {
  return (
    <div className="min-h-screen bg-gray-900 text-gray-200 p-4 md:p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <div className="flex items-center gap-4 mb-4">
            <div className="text-5xl text-cyan-400">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div>
              <h1 className="text-4xl font-bold text-cyan-200">Attendance</h1>
              <p className="text-gray-400 text-lg">Track daily presence and working hours</p>
            </div>
          </div>
        </div>

        {/* Placeholder Content */}
        <div className="bg-gray-800 rounded-3xl p-12 text-center">
          <div className="max-w-md mx-auto">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-gray-700 rounded-2xl mb-8">
              <FontAwesomeIcon icon={faCalendarAlt} className="text-5xl text-cyan-400" />
            </div>

            <h2 className="text-3xl font-semibold text-gray-100 mb-4">
              Attendance Module
            </h2>
            
            <p className="text-gray-400 text-lg leading-relaxed mb-10">
              This feature is planned for future implementation.<br />
              You can track employee check-in/check-out, leaves, and generate monthly reports here.
            </p>

            <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 mb-8">
              <div className="flex items-start gap-4 text-left">
                <div className="text-cyan-400 mt-1">
                  <FontAwesomeIcon icon={faInfoCircle} />
                </div>
                <div>
                  <p className="font-medium text-gray-300">Route Already Configured</p>
                  <p className="text-gray-500 text-sm mt-1">
                    The backend route and navigation are ready. 
                    We can build the full attendance system (with biometric / QR / manual punch) whenever you're ready.
                  </p>
                </div>
              </div>
            </div>

            <a
              href="/chronocheck-home"
              className="bg-cyan-600 hover:bg-cyan-500 w-fit px-2 py-1 rounded-2xl font-medium transition-colors inline-flex items-center gap-3"
            >
              <FontAwesomeIcon icon={faClock} />
              Open ChronoCheck Attendance
            </a>
          </div>
        </div>

        {/* Future Features Teaser */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6 text-center">
            <div className="text-3xl mb-3">🕒</div>
            <h4 className="font-semibold text-cyan-100">Daily Punch In/Out</h4>
            <p className="text-gray-500 text-sm mt-2">Manual + Future QR / Biometric</p>
          </div>
          <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6 text-center">
            <div className="text-3xl mb-3">📅</div>
            <h4 className="font-semibold text-cyan-100">Monthly Reports</h4>
            <p className="text-gray-500 text-sm mt-2">Attendance summary + Late / Early marks</p>
          </div>
          <div className="bg-gray-800/50 border border-gray-700 rounded-2xl p-6 text-center">
            <div className="text-3xl mb-3">📊</div>
            <h4 className="font-semibold text-cyan-100">Leave Management</h4>
            <p className="text-gray-500 text-sm mt-2">Apply, Approve &amp; Track leaves</p>
          </div>
        </div>

        <div className="text-center text-gray-300 text-sm mt-16">
          MiniERP Attendance • Coming Soon
        </div>
      </div>
    </div>
  );
};

export default MiniERPAttendance;